import ServiceDetailLayout from "@/components/site/ServiceDetailLayout";

export default function ManagedServices() {
  return (
    <ServiceDetailLayout
      eyebrow="Managed Services"
      title="Ongoing marketing operations support without the overhead."
      subtitle="Xadentra provides continuous marketing automation support so your team can keep campaigns moving, improve processes, and maintain platform quality."
      cta="Get Automation Support"
      seo={{
        title: "Marketing Automation Managed Services | Adobe Marketo Engage / SFDC Support — Xadentra",
        description: "Ongoing Adobe Marketo Engage and Salesforce campaign execution, QA, optimization, troubleshooting, reporting, and documentation as a managed service.",
        path: "/services/managed-services",
      }}
      sections={[
        {
          heading: "Day-to-day operations",
          items: [
            "Weekly campaign support and request intake",
            "Adobe Marketo Engage troubleshooting and sync issue resolution",
            "Workflow optimization and program tuning",
            "Campaign QA and pre-launch review",
            "Landing page and email updates",
          ],
        },
        {
          heading: "Governance & enablement",
          items: [
            "Data cleanup recommendations and dedupe",
            "Documentation and platform governance",
            "Stakeholder request management",
            "Quarterly health audits",
            "Enablement and team training",
          ],
        },
        {
          heading: "Reporting & continuous improvement",
          items: [
            "Reporting support and dashboard upkeep",
            "Performance reviews with revenue context",
            "Experimentation framework and test backlog",
            "Roadmap planning across the quarter",
            "Executive-ready monthly summary",
          ],
        },
      ]}
      related={[
        { to: "/marketo-services", label: "Adobe Marketo Engage Services" },
        { to: "/services/campaign-operations", label: "Campaign Operations" },
        { to: "/services/reporting-attribution", label: "Reporting & Attribution" },
      ]}
    />
  );
}
